import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';

import { HotelColorDirective } from '../../directives/text-hotel-color.directive';
import { ChipComponent } from '../chip';
import { ImageSkeletonComponent } from '../image-skeleton/image-skeleton.component';
import { SkeletonAppearance } from '../image-skeleton/skeleton-apperance';

@Component({
  selector: 'ctr-product-card',
  imports: [ImageSkeletonComponent, HotelColorDirective, MatRippleModule, ChipComponent],
  templateUrl: './product-card.component.html',
  styleUrl: './product-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductCardComponent {
  @Input() imageUrl: string | undefined = '';
  @Input() title: string | undefined = '';
  @Input() price: string | undefined | null = '';
  @Input() priceDiscount: string | undefined | null = '';
  @Input() tags: string[] = [];
  @Output() openCard = new EventEmitter<void>();
  readonly typeCover = SkeletonAppearance.CIRCLE;

  clickCard() {
    this.openCard.emit();
  }
}
